import { render, staticRenderFns } from "./SetupMFA.vue?vue&type=template&id=1add6202&"
import script from "./SetupMFA.vue?vue&type=script&lang=js&"
export * from "./SetupMFA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports